var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMalware(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 271,
    viewBox: "0 0 208 271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.574 33.1201V270.37H171.324H175.164H207.874V237.65V33.1201H38.574Z",
    fill: "#080E04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.014 25.5601V262.81H163.764H167.604H200.314V230.09V25.5601H31.014Z",
    fill: "#6CCA36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.454 18.0001V255.25H156.204H160.044H192.754V222.53V18.0001H23.454Z",
    fill: "#E8FFDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.25 144.749C134.25 163.388 122.498 178.499 108.001 178.499C93.5031 178.499 81.751 163.388 81.751 144.749C81.751 126.111 93.5031 111 108.001 111C122.498 111 134.25 126.111 134.25 144.749Z",
    stroke: "#080E04",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.025 116.25C122.676 114.577 123.006 112.795 123 111C123 105.64 120.142 100.688 115.501 98.0093C110.86 95.3302 105.141 95.3302 100.5 98.0093C95.8588 100.688 93.001 105.64 93.001 111C92.9947 112.795 93.3243 114.576 93.9756 116.25",
    stroke: "#080E04",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153 144.749H134.25",
    stroke: "#080E04",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7503 144.749H63",
    stroke: "#080E04",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M153 111L148.5 117C144.252 122.667 137.583 126.002 130.5 125.999H129.825",
    stroke: "#080E04",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1753 126H83.5872C77.609 126.007 71.8726 123.633 67.6509 119.4L63.0005 114.75",
    stroke: "#080E04",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153 178.499L148.5 172.499C144.252 166.832 137.583 163.497 130.5 163.5H129.825",
    stroke: "#080E04",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1753 163.499H83.5872C77.609 163.492 71.8726 165.866 67.6509 170.099L63.0005 174.749",
    stroke: "#080E04",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2257 12.5316H2.08253C0.933293 12.5316 0 13.4654 0 14.6141V34.1493C0 35.2264 0.933819 36.1603 2.08253 36.1603H17.5957L17.5952 12.5313L15.2257 12.5316Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6222 47.8672L19.7503 36.3757C19.3911 36.2319 19.1757 35.8727 19.1757 35.4419V13.1776C19.1757 12.7467 19.3911 12.4592 19.7503 12.2438L48.6222 0.752239C49.2684 0.465175 49.9147 0.967662 49.9147 1.68606V47.0047C49.9868 47.6515 49.2684 48.154 48.6222 47.8669V47.8672Z",
    fill: "#6CCA36"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1963 16.4817C61.4062 13.9677 60.329 11.6698 58.9645 9.73047C57.959 8.22199 55.7327 8.36576 54.8704 9.9459C54.4396 10.8076 54.5112 11.8131 55.0859 12.5314C56.3784 14.1832 57.4559 16.2662 58.1739 18.5642C60.4002 25.6746 59.0356 33.6465 55.0859 38.7458C54.5112 39.4642 54.4396 40.4696 54.8704 41.3313C55.7321 42.9113 57.8869 43.0551 58.8923 41.5467C63.4171 34.9397 64.925 25.3166 62.1963 16.4814V16.4817Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3783 12.3161C68.0136 7.9351 66.0027 4.12861 63.561 0.968516C62.4834 -0.467764 60.4007 -0.252366 59.6107 1.25608L59.5391 1.32772C59.1082 2.18941 59.1799 3.19492 59.8261 3.98495C62.1962 6.78594 64.1356 10.3053 65.4281 14.3988C69.0909 26.1056 66.5052 39.1768 59.6824 47.2207C59.0361 47.9391 58.964 49.0162 59.3953 49.8779L59.467 49.9496C60.257 51.4581 62.3395 51.6734 63.4172 50.3088C70.8863 40.6855 73.6157 25.7462 69.3783 12.3158V12.3161Z",
    fill: "#6CCA36"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalware);
export default __webpack_public_path__ + "static/media/malware.0e3a19f7ed737d3ac31e82901bb1d436.svg";
export { ForwardRef as ReactComponent };